import { StringTools } from '../../Misc/stringTools';
/** @hidden */
var ShaderCodeNode = /** @class */function () {
  function ShaderCodeNode() {
    this.children = [];
  }
  ShaderCodeNode.prototype.isValid = function (preprocessors) {
    return true;
  };
  ShaderCodeNode.prototype.process = function (preprocessors, options) {
    var result = "";
    if (this.line) {
      var value = this.line;
      var processor = options.processor;
      if (processor) {
        // This must be done before other replacements to avoid mistakenly changing something that was already changed.
        if (processor.lineProcessor) {
          value = processor.lineProcessor(value, options.isFragment);
        }
        if (processor.attributeProcessor && StringTools.StartsWith(this.line, "attribute")) {
          value = processor.attributeProcessor(this.line);
        } else if (processor.varyingProcessor && StringTools.StartsWith(this.line, "varying")) {
          value = processor.varyingProcessor(this.line, options.isFragment);
        } else if ((processor.uniformProcessor || processor.uniformBufferProcessor) && StringTools.StartsWith(this.line, "uniform")) {
          var regex = /uniform (.+) (.+)/;
          if (regex.test(this.line)) {
            // uniform
            if (processor.uniformProcessor) {
              value = processor.uniformProcessor(this.line, options.isFragment);
            }
          } else {
            // Uniform buffer
            if (processor.uniformBufferProcessor) {
              value = processor.uniformBufferProcessor(this.line, options.isFragment);
              options.lookForClosingBracketForUniformBuffer = true;
            }
          }
        }
        if (processor.endOfUniformBufferProcessor) {
          if (options.lookForClosingBracketForUniformBuffer && this.line.indexOf("}") !== -1) {
            options.lookForClosingBracketForUniformBuffer = false;
            value = processor.endOfUniformBufferProcessor(this.line, options.isFragment);
          }
        }
      }
      result += value + "\r\n";
    }
    this.children.forEach(function (child) {
      result += child.process(preprocessors, options);
    });
    if (this.additionalDefineKey) {
      preprocessors[this.additionalDefineKey] = this.additionalDefineValue || "true";
    }
    return result;
  };
  return ShaderCodeNode;
}();
export { ShaderCodeNode };